/**
 * Contracts belong to a company (Akhil, 2026-10-26: GreenSpire's contract suppliers were offered
 * on Aqua Maris enquiries). `items.get_active_blanket_orders` returns every company's orders and
 * ignores a `company` filter, so the screen filters by each order's own `Blanket Order.company`.
 *
 * Fails open: an enquiry with no company, or an order whose company is not known, is shown — a
 * missing lookup must cost a longer list, never a contract that silently vanished.
 */
const norm = (s: string) => s.trim().toLowerCase()

export function ordersForCompany<T extends { name: string }>(orders: readonly T[], companyOf: ReadonlyMap<string, string>, company: string): T[] {
  const wanted = norm(company)
  if (wanted === '') return [...orders]
  return orders.filter((o) => {
    const own = companyOf.get(o.name)
    return own === undefined || own.trim() === '' || norm(own) === wanted
  })
}

/**
 * The company contracts are filtered by (Akhil, 2026-10-26): the RFQ builder's — the enquiry's own —
 * first, then the one chosen in Bosun's settings. Empty when neither is set, which filters nothing.
 */
export function contractCompany(enquiryCompany: string | null | undefined, settingsCompany: string | null | undefined): string {
  return (enquiryCompany ?? '').trim() || (settingsCompany ?? '').trim()
}
